module.exports = __webpack_public_path__ + "static/img/05touxiao.1ab41012.gif";